import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as purchaseOrderSelectors, actions as purchaseOrderActions } from 'ducks/inventoryEnquiry/reordering/purchaseOrders';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { search } from 'api/inventoryEnquiry/reordering/purchaseOrders';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { actions as formActions } from 'ducks/form';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'IEPurchaseOrders',
  columnDefs: purchaseOrderSelectors.columns(state),
  rowData: purchaseOrderSelectors.data(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: purchaseOrderSelectors.gridOptions(state),
  isLoading: purchaseOrderSelectors.isLoading(state),
  filterRow: purchaseOrderSelectors.filterRow(state),
  selectedFilters: purchaseOrderSelectors.selectedFilters(state),
  reqParams: (productSelectors.selected(state) || params.get('ProductId')) && {
    ProductId: (productSelectors.selected(state) && productSelectors.selected(state).ProductId) || params.get('ProductId')
  },
  appliedFilters: purchaseOrderSelectors.filterRow(state) && filterSelectors.getFilters(state, purchaseOrderSelectors.filterRow(state).formName),
  apiMethod: search
})

export const actions = {
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  changeSelectedTab: uiActions.changeSelectedTab,
  setSelectedOrderLine: purchaseOrderActions.setSelected,
  changeOperationMode: operationActions.changeOperationMode,
  applyFilters: filterActions.applyFilters
}
